import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import routesConfig from "./routesConfig";
/*
 * Plugins
 */
Vue.use(VueRouter);

/*
 * Configure Router
 */
const router = new VueRouter({
    base: process.env.BASE_URL,
    mode: "hash",
    routes: routesConfig,
});

router.afterEach((to, from) => {
    Vue.nextTick(() => {
        if (store.state.application.startupData.brandedMode) document.title = "Loomis Direct - Lounge";
        else if (to.name) document.title = `${to.name} - C-Link`;
        else document.title = "C-Link";
    });
});

export default router;
